import React from "react";
import { getIcon } from "../../../Components/Functions";

const SearchHeader = ({ count, changeView, expandMobileSearch, setExpandMobileSearch }) => {
	const options = ["Grid", "List"];

	return (
		<div className="columns is-12" style={{ 
            borderBottom: '1px solid #f4f4f4',
            marginBottom: '1.5rem'
        }}>
            <style>
                {window.innerWidth < 900 ? `

                        .search-engine-v2 .filter-box {
                            left: ${ !expandMobileSearch ? 100 : 0}% !important;
                            transition: 1s
                        }

                ` : ""}
            </style>
			<div className="column is-6">
				<h2 style={{ fontWeight: 900, fontSize: 18 }}>Results ({count})</h2>
			</div>
            <div
                onClick={() => setExpandMobileSearch(!expandMobileSearch)}
				className="sort-div mobile-edit-search column is-6"
				style={{
					fontSize: 13,
					flexDirection: "row",
					alignItems: "center",
					display: "none",
					justifyContent: "end",
                    cursor: "pointer"
				}}
			>
				<label style={{ marginRight: 10, textTransform: "uppercase", display: "inline-flex", alignItems: "center", cursor: "pointer" }}
                    dangerouslySetInnerHTML={{ __html: `${getIcon("edit", { width: 15, height: 15, color: "#37514b", style: "margin-right: 5px" })} Edit Search` }}
                >
                    
                </label>
			</div>
			<div
				className="sort-div orientation column is-6"
				style={{
					fontSize: 13,
					flexDirection: "row",
					alignItems: "center",
					display: "flex",
					justifyContent: "end",
				}}
			>
				<label style={{ marginRight: 10, textTransform: "uppercase" }}>View as:  </label>
				<div className="select">
					<select defaultValue={""} onChange={(e) => changeView && changeView(e.target.value)}>
						{(options || []).map((item) => {
							return (
								<option value={item?.value || item}>
									{item?.label || item}
								</option>
							);
						})}
					</select>
				</div>
			</div>
		</div>
	);
};

export default SearchHeader;
